<template>
  <div>
    <div class="flex items-center justify-between">
      <p class="title ">{{ title }}</p>
      <div class="ml-auto">
        <search-nav-item-keyword size="large" placeholder="사용자 ID 검색" v-model="searchUserId"/>
      </div>
    </div>
    <vs-table
      v-if="type === 'info'"
      @selected="handleSelected"
      @sort="handleSort"
      @search="handleSearch"
      pagination
      :max-items="(getUsers && getUsers.length > 0) ? 5 : 1"
      :data="getUsers"
      class="mt-5"
    >
      <template slot="thead">
        <vs-th>No.</vs-th>
        <vs-th>구분</vs-th>
        <vs-th>사용자명</vs-th>
        <vs-th>사용자 ID</vs-th>
        <vs-th>연락처</vs-th>
        <vs-th v-if="isEmail">이메일</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td>{{ data[indextr].id }}</vs-td>
          <vs-td>{{ data[indextr].company_id }}</vs-td>
          <vs-td>{{ data[indextr].name}}</vs-td>
          <vs-td>{{ data[indextr].username }}</vs-td>
          <vs-td>{{ data[indextr].phone }}</vs-td>
          <vs-td v-if="isEmail">{{ data[indextr].email }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-table
      v-else
      @selected="handleSelected"
      @sort="handleSort"
      @search="handleSearch"
      pagination
      :max-items="(getUsers && getUsers.length > 0) ? 5 : 1"
      :data="getUsers"
      class="mt-5"
    >
      <template slot="thead">
        <vs-th>No.</vs-th>
        <vs-th>구분</vs-th>
        <vs-th>사용자명</vs-th>
        <vs-th>사용자 ID</vs-th>
        <vs-th>연락처</vs-th>
        <vs-th v-if="isEmail">이메일</vs-th>
        <vs-th>프로젝트 권한</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td>{{ indextr + 1 }}</vs-td>
          <vs-td>{{ data[indextr].company_id }}</vs-td>
          <vs-td>{{ data[indextr].name }}</vs-td>
          <vs-td>{{ data[indextr].username }}</vs-td>
          <vs-td>{{ data[indextr].phone }}</vs-td>
          <vs-td v-if="isEmail">{{ data[indextr].email }}</vs-td>
          <vs-td class="flex">
            <vs-select v-model="tr.join_project" autocomplete @change="onChangeJoinProject">
              <vs-select-item text="미참여" :value="false" />
              <vs-select-item text="참여" :value="true"  />
            </vs-select>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import SearchNavItemKeyword from '@/components/nav/SearchNavItemKeyword'
export default {
  name: 'CompanyUserAuthModule',
  components: {SearchNavItemKeyword},
  props: {
    value: Array,
    type: {
      type: String,
      default: () => {
        return ''
      }
    },
    users: Array,
    title: {
      type: String,
      default: () => {
        return '참여 인원 정보'
      }
    },
    isEmail: {
      type: Boolean,
      default: true,
    }
  },
  data () {
    return {
      joinProjects: [],
      page: {
        current: 1,
        perPage: 100,
      },
      searchUserId: ''
    }
  },
  computed: {
    getUsers () {
      const list = []
      if (this.users) {
        for (const user of this.users) {
          if (this.searchUserId) {
            if (user.username.indexOf(this.searchUserId) >= 0) {
              list.push(user)
            }
          } else {
            list.push(user)
          }
        }
      }
      return list
    }
  },
  watch: {
    value (data) {
      this.joinProjects = data
    }
  },
  mounted () {
    this.joinProjects = this.value
  },
  methods: {

    handleSelected () {

    },
    handleSort () {

    },
    handleSearch () {

    },
    onChangeJoinProject () {
      const list = []
      for (const user of this.users) {
        if (user.join_project) {
          list.push(user)
        }
      }
      this.$emit('input', list)
    }
  }
}
</script>

<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;
  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}
.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.size-search{
  width: 200px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}
.search-item {
  width: 100% !important;
  margin: 0 !important;
  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }
  &::v-deep > div:last-child {
    flex: 1 !important;
    .con-select {
      width: 100%;
    }
  }
}
.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0px;
  display: inline-block;

  .vx-card__body {
    padding: 0px !important;
  }
}

span.up {
  color: #28c76f;
}
span.down {
  color: #ea5455;
}
.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
